//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class V1ReportsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    //custom code to format date without localization
    formatDateToLocalISO(date: Date): string {
        const pad = (num: number) => num.toString().padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    /**
     * @return OK
     */
    getOpenInvoicesReport(endDate: Date, cancelToken?: CancelToken): Promise<OpenInvoiceDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/reports/open-invoices/{endDate}";

                    if (endDate === undefined || endDate === null)
                throw new Error("The parameter 'endDate' must be defined.");
                    url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + this.formatDateToLocalISO(endDate) : "null"));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenInvoicesReport(_response);
        });
    }

    protected processGetOpenInvoicesReport(response: AxiosResponse): Promise<OpenInvoiceDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = OpenInvoiceDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<OpenInvoiceDtoNotPagedDataResponseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OpenInvoiceDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getARBuckets(endDate: Date, cancelToken?: CancelToken): Promise<ARBucketDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/reports/ar-buckets/{endDate}";

                    if (endDate === undefined || endDate === null)
                throw new Error("The parameter 'endDate' must be defined.");
                    url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + this.formatDateToLocalISO(endDate) : "null"));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetARBuckets(_response);
        });
    }

    protected processGetARBuckets(response: AxiosResponse): Promise<ARBucketDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ARBucketDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<ARBucketDtoNotPagedDataResponseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ARBucketDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getFreeMonthsByRepByMonth(repStatus: number, startDate?: Date | null | undefined, endDate?: Date | null | undefined, cancelToken?: CancelToken): Promise<FreeMonthDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/reports/free-months-by-rep-by-month/{repStatus}?";

                    if (repStatus === undefined || repStatus === null)
                throw new Error("The parameter 'repStatus' must be defined.");
                    url_ = url_.replace("{repStatus}", encodeURIComponent("" + repStatus));
                                    if (startDate !== undefined && startDate !== null)
                            url_ += "startDate=" + encodeURIComponent(startDate ? "" + this.formatDateToLocalISO(startDate) : "") + "&";
                            if (endDate !== undefined && endDate !== null)
                            url_ += "endDate=" + encodeURIComponent(endDate ? "" + this.formatDateToLocalISO(endDate) : "") + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFreeMonthsByRepByMonth(_response);
        });
    }

    protected processGetFreeMonthsByRepByMonth(response: AxiosResponse): Promise<FreeMonthDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = FreeMonthDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<FreeMonthDtoNotPagedDataResponseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FreeMonthDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getOfferUpSalesReport( cancelToken?: CancelToken): Promise<OfferUpSalesDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/reports/offer-up-sales-report";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOfferUpSalesReport(_response);
        });
    }

    protected processGetOfferUpSalesReport(response: AxiosResponse): Promise<OfferUpSalesDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = OfferUpSalesDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<OfferUpSalesDtoNotPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferUpSalesDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getTestDriveRewardsSalesReport(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<TestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto> {
        let url_ = this.baseUrl + "/api/v1/reports/test-drive-rewards-sales-report?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTestDriveRewardsSalesReport(_response);
        });
    }

    protected processGetTestDriveRewardsSalesReport(response: AxiosResponse): Promise<TestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto.fromJS(resultData200);
            return Promise.resolve<TestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto>(null as any);
    }

    /**
     * @return OK
     */
    apiTest( cancelToken?: CancelToken): Promise<TestDto> {
        let url_ = this.baseUrl + "/api/v1/reports/tests";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiTest(_response);
        });
    }

    protected processApiTest(response: AxiosResponse): Promise<TestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TestDto.fromJS(resultData200);
            return Promise.resolve<TestDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestDto>(null as any);
    }
}

export class ARBucketDto implements IARBucketDto {
    id?: string | undefined;
    name?: string | undefined;
    zeroToThirty?: number | undefined;
    thirtyOneToSixty?: number | undefined;
    sixtyOneToNinety?: number | undefined;
    ninetyPlus?: number | undefined;
    grandTotal?: number | undefined;

    constructor(data?: IARBucketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.zeroToThirty = _data["zeroToThirty"];
            this.thirtyOneToSixty = _data["thirtyOneToSixty"];
            this.sixtyOneToNinety = _data["sixtyOneToNinety"];
            this.ninetyPlus = _data["ninetyPlus"];
            this.grandTotal = _data["grandTotal"];
        }
    }

    static fromJS(data: any): ARBucketDto {
        data = typeof data === 'object' ? data : {};
        let result = new ARBucketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["zeroToThirty"] = this.zeroToThirty;
        data["thirtyOneToSixty"] = this.thirtyOneToSixty;
        data["sixtyOneToNinety"] = this.sixtyOneToNinety;
        data["ninetyPlus"] = this.ninetyPlus;
        data["grandTotal"] = this.grandTotal;
        return data;
    }

    clone(): ARBucketDto {
        const json = this.toJSON();
        let result = new ARBucketDto();
        result.init(json);
        return result;
    }
}

export interface IARBucketDto {
    id?: string | undefined;
    name?: string | undefined;
    zeroToThirty?: number | undefined;
    thirtyOneToSixty?: number | undefined;
    sixtyOneToNinety?: number | undefined;
    ninetyPlus?: number | undefined;
    grandTotal?: number | undefined;
}

export class ARBucketDtoNotPagedDataResponseDto implements IARBucketDtoNotPagedDataResponseDto {
    data!: ARBucketDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IARBucketDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ARBucketDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ARBucketDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ARBucketDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): ARBucketDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new ARBucketDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IARBucketDtoNotPagedDataResponseDto {
    data: ARBucketDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class ApiResponseDto implements IApiResponseDto {
    id!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): ApiResponseDto {
        const json = this.toJSON();
        let result = new ApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApiResponseDto {
    id: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class FreeMonthDto implements IFreeMonthDto {
    salesPerson?: string | undefined;
    january!: number;
    february!: number;
    march!: number;
    april!: number;
    may!: number;
    june!: number;
    july!: number;
    august!: number;
    september!: number;
    october!: number;
    november!: number;
    december!: number;
    totalFreeMonths!: number;

    constructor(data?: IFreeMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesPerson = _data["salesPerson"];
            this.january = _data["january"];
            this.february = _data["february"];
            this.march = _data["march"];
            this.april = _data["april"];
            this.may = _data["may"];
            this.june = _data["june"];
            this.july = _data["july"];
            this.august = _data["august"];
            this.september = _data["september"];
            this.october = _data["october"];
            this.november = _data["november"];
            this.december = _data["december"];
            this.totalFreeMonths = _data["totalFreeMonths"];
        }
    }

    static fromJS(data: any): FreeMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesPerson"] = this.salesPerson;
        data["january"] = this.january;
        data["february"] = this.february;
        data["march"] = this.march;
        data["april"] = this.april;
        data["may"] = this.may;
        data["june"] = this.june;
        data["july"] = this.july;
        data["august"] = this.august;
        data["september"] = this.september;
        data["october"] = this.october;
        data["november"] = this.november;
        data["december"] = this.december;
        data["totalFreeMonths"] = this.totalFreeMonths;
        return data;
    }

    clone(): FreeMonthDto {
        const json = this.toJSON();
        let result = new FreeMonthDto();
        result.init(json);
        return result;
    }
}

export interface IFreeMonthDto {
    salesPerson?: string | undefined;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    totalFreeMonths: number;
}

export class FreeMonthDtoNotPagedDataResponseDto implements IFreeMonthDtoNotPagedDataResponseDto {
    data!: FreeMonthDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IFreeMonthDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FreeMonthDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): FreeMonthDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeMonthDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): FreeMonthDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new FreeMonthDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IFreeMonthDtoNotPagedDataResponseDto {
    data: FreeMonthDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class OfferUpSalesDto implements IOfferUpSalesDto {
    dealerId!: number;
    dealerName?: string | undefined;
    dateEnrolled?: Date | undefined;
    address1?: string | undefined;
    offerUp249!: number;
    offerUp349!: number;
    offerUp449!: number;

    constructor(data?: IOfferUpSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.dealerName = _data["dealerName"];
            this.dateEnrolled = _data["dateEnrolled"] ? new Date(_data["dateEnrolled"].toString()) : <any>undefined;
            this.address1 = _data["address1"];
            this.offerUp249 = _data["offerUp249"];
            this.offerUp349 = _data["offerUp349"];
            this.offerUp449 = _data["offerUp449"];
        }
    }

    static fromJS(data: any): OfferUpSalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferUpSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["dealerName"] = this.dealerName;
        data["dateEnrolled"] = this.dateEnrolled ? this.dateEnrolled.toISOString() : <any>undefined;
        data["address1"] = this.address1;
        data["offerUp249"] = this.offerUp249;
        data["offerUp349"] = this.offerUp349;
        data["offerUp449"] = this.offerUp449;
        return data;
    }

    clone(): OfferUpSalesDto {
        const json = this.toJSON();
        let result = new OfferUpSalesDto();
        result.init(json);
        return result;
    }
}

export interface IOfferUpSalesDto {
    dealerId: number;
    dealerName?: string | undefined;
    dateEnrolled?: Date | undefined;
    address1?: string | undefined;
    offerUp249: number;
    offerUp349: number;
    offerUp449: number;
}

export class OfferUpSalesDtoNotPagedDataResponseDto implements IOfferUpSalesDtoNotPagedDataResponseDto {
    data!: OfferUpSalesDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IOfferUpSalesDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OfferUpSalesDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): OfferUpSalesDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferUpSalesDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): OfferUpSalesDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new OfferUpSalesDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IOfferUpSalesDtoNotPagedDataResponseDto {
    data: OfferUpSalesDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class OpenInvoiceDto implements IOpenInvoiceDto {
    dealerInvoice_ID!: number;
    id?: string | undefined;
    name?: string | undefined;
    productName?: string | undefined;
    productAmount!: number;
    paymentMethod?: string | undefined;
    invoiceDate!: Date;
    dueDate!: Date;
    invoiceAmount!: number;
    totalAmountDue!: number;

    constructor(data?: IOpenInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerInvoice_ID = _data["dealerInvoice_ID"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.productName = _data["productName"];
            this.productAmount = _data["productAmount"];
            this.paymentMethod = _data["paymentMethod"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.invoiceAmount = _data["invoiceAmount"];
            this.totalAmountDue = _data["totalAmountDue"];
        }
    }

    static fromJS(data: any): OpenInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpenInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerInvoice_ID"] = this.dealerInvoice_ID;
        data["id"] = this.id;
        data["name"] = this.name;
        data["productName"] = this.productName;
        data["productAmount"] = this.productAmount;
        data["paymentMethod"] = this.paymentMethod;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["invoiceAmount"] = this.invoiceAmount;
        data["totalAmountDue"] = this.totalAmountDue;
        return data;
    }

    clone(): OpenInvoiceDto {
        const json = this.toJSON();
        let result = new OpenInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IOpenInvoiceDto {
    dealerInvoice_ID: number;
    id?: string | undefined;
    name?: string | undefined;
    productName?: string | undefined;
    productAmount: number;
    paymentMethod?: string | undefined;
    invoiceDate: Date;
    dueDate: Date;
    invoiceAmount: number;
    totalAmountDue: number;
}

export class OpenInvoiceDtoNotPagedDataResponseDto implements IOpenInvoiceDtoNotPagedDataResponseDto {
    data!: OpenInvoiceDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IOpenInvoiceDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OpenInvoiceDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): OpenInvoiceDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpenInvoiceDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): OpenInvoiceDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new OpenInvoiceDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IOpenInvoiceDtoNotPagedDataResponseDto {
    data: OpenInvoiceDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class TestDriveRewardsSalesDto implements ITestDriveRewardsSalesDto {
    dealerId!: number;
    dealerName?: string | undefined;
    dateEnrolled?: Date | undefined;
    address1?: string | undefined;
    testDrive149!: number;
    testDrive199!: number;
    testDrive249!: number;

    constructor(data?: ITestDriveRewardsSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.dealerName = _data["dealerName"];
            this.dateEnrolled = _data["dateEnrolled"] ? new Date(_data["dateEnrolled"].toString()) : <any>undefined;
            this.address1 = _data["address1"];
            this.testDrive149 = _data["testDrive149"];
            this.testDrive199 = _data["testDrive199"];
            this.testDrive249 = _data["testDrive249"];
        }
    }

    static fromJS(data: any): TestDriveRewardsSalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDriveRewardsSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["dealerName"] = this.dealerName;
        data["dateEnrolled"] = this.dateEnrolled ? this.dateEnrolled.toISOString() : <any>undefined;
        data["address1"] = this.address1;
        data["testDrive149"] = this.testDrive149;
        data["testDrive199"] = this.testDrive199;
        data["testDrive249"] = this.testDrive249;
        return data;
    }

    clone(): TestDriveRewardsSalesDto {
        const json = this.toJSON();
        let result = new TestDriveRewardsSalesDto();
        result.init(json);
        return result;
    }
}

export interface ITestDriveRewardsSalesDto {
    dealerId: number;
    dealerName?: string | undefined;
    dateEnrolled?: Date | undefined;
    address1?: string | undefined;
    testDrive149: number;
    testDrive199: number;
    testDrive249: number;
}

export class TestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto implements ITestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto {
    data!: TestDriveRewardsSalesDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;
    totals!: TestDriveRewardsSalesTotalsDto;

    constructor(data?: ITestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
            this.totals = new TestDriveRewardsSalesTotalsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TestDriveRewardsSalesDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
            this.totals = _data["totals"] ? TestDriveRewardsSalesTotalsDto.fromJS(_data["totals"]) : new TestDriveRewardsSalesTotalsDto();
        }
    }

    static fromJS(data: any): TestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        return data;
    }

    clone(): TestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto {
        const json = this.toJSON();
        let result = new TestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto();
        result.init(json);
        return result;
    }
}

export interface ITestDriveRewardsSalesDtoTestDriveRewardsSalesTotalsDtoPagedDataResponseWithTotalsDto {
    data: TestDriveRewardsSalesDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
    totals: TestDriveRewardsSalesTotalsDto;
}

export class TestDriveRewardsSalesTotalsDto implements ITestDriveRewardsSalesTotalsDto {
    testDrive149Count!: number;
    testDrive199Count!: number;
    testDrive249Count!: number;

    constructor(data?: ITestDriveRewardsSalesTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testDrive149Count = _data["testDrive149Count"];
            this.testDrive199Count = _data["testDrive199Count"];
            this.testDrive249Count = _data["testDrive249Count"];
        }
    }

    static fromJS(data: any): TestDriveRewardsSalesTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDriveRewardsSalesTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testDrive149Count"] = this.testDrive149Count;
        data["testDrive199Count"] = this.testDrive199Count;
        data["testDrive249Count"] = this.testDrive249Count;
        return data;
    }

    clone(): TestDriveRewardsSalesTotalsDto {
        const json = this.toJSON();
        let result = new TestDriveRewardsSalesTotalsDto();
        result.init(json);
        return result;
    }
}

export interface ITestDriveRewardsSalesTotalsDto {
    testDrive149Count: number;
    testDrive199Count: number;
    testDrive249Count: number;
}

export class TestDto implements ITestDto {
    prop?: string | undefined;

    constructor(data?: ITestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prop = _data["prop"];
        }
    }

    static fromJS(data: any): TestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prop"] = this.prop;
        return data;
    }

    clone(): TestDto {
        const json = this.toJSON();
        let result = new TestDto();
        result.init(json);
        return result;
    }
}

export interface ITestDto {
    prop?: string | undefined;
}

export class V1ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isV1ApiException = true;

    static isV1ApiException(obj: any): obj is V1ApiException {
        return obj.isV1ApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new V1ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}